import { render, staticRenderFns } from "./UserChangePassModal.vue?vue&type=template&id=4b7f263c&scoped=true&"
import script from "./UserChangePassModal.vue?vue&type=script&lang=js&"
export * from "./UserChangePassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f263c",
  null
  
)

export default component.exports